// extracted by mini-css-extract-plugin
export var button = "cookies-module--button--e+XTd";
export var container = "cookies-module--container--7esjY";
export var content = "cookies-module--content--IZwmH";
export var emoji = "cookies-module--emoji--HfwSF";
export var text = "cookies-module--text--VDGu6";
export var title = "cookies-module--title--oU9Ih";